module.exports = __webpack_public_path__ + "img/1557614079497019394.60c16a95.png";